/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import {
  ISubsidiaryListResponse,
  ISubsidiaryResponse
} from '@bvi/api-interfaces/response/manage-base-data';
import { ICreateSubsidiaryRequest } from "@bvi/api-interfaces/request/subsidiary";

export const subsidiaryApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getSubsidiaryList: builder.query<ISubsidiaryListResponse, void>({
      query: () => ({
        url: routes.subsidiary.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.SUBSIDIARY, getResponseData(result)),
            getListTag(TagTypes.SUBSIDIARY),
          ]
          : [getListTag(TagTypes.SUBSIDIARY)],
    }),

    getByIdSubsidiary: builder.query<ISubsidiaryResponse, number>({
      query: (id) => ({
        url: routes.subsidiary.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.SUBSIDIARY)
    }),

    createSubsidiary: builder.mutation<
      ISubsidiaryResponse,
      ICreateSubsidiaryRequest
    >({
      query: (data) => ({
        url: routes.subsidiary.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.SUBSIDIARY)),
    }),


    updateSubsidiary: builder.mutation<
      ISubsidiaryResponse,
      WithId<ICreateSubsidiaryRequest>
    >({
      query: ([id, data]) => ({
        url: routes.subsidiary.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.SUBSIDIARY)),
    }),

    deleteSubsidiary: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.subsidiary.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.SUBSIDIARY)),
    }),
  })
});

export const {
  useGetSubsidiaryListQuery,
  useLazyGetSubsidiaryListQuery,
  useGetByIdSubsidiaryQuery,
  useLazyGetByIdSubsidiaryQuery,
  useCreateSubsidiaryMutation,
  useUpdateSubsidiaryMutation,
  useDeleteSubsidiaryMutation
} = subsidiaryApi;
